<template>
  <div class="w-full flex flex-row gap-1">
    <div v-for="category in filteredCategories" :key="category.id">
      <el-tooltip
        :content="category.name"
        effect="dark"
        :disabled="category.name.length < 15"
        :raw-content="true"
        placement="top-start"
      >
        <ElTag
          size="small"
          effect="dark"
          round
          class="cursor-pointer"
          @click="redirectToSearch(category)"
        >
          <span>{{ wrapCategoryName(category.name) }}</span>
        </ElTag>
      </el-tooltip>
    </div>
    <div v-if="moreCategories.length">
      <el-popover placement="bottom" :width="400">
        <template #reference>
          <el-button text size="small">Show more</el-button>
        </template>
        <div class="flex w-full gap-1 flex-wrap">
          <ElTag
            size="small"
            effect="dark"
            round
            class="cursor-pointer"
            v-for="category in moreCategories"
            :key="category.id"
            @click="redirectToSearch(category)"
          >
            <span>{{ category.name }}</span>
          </ElTag>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script setup>
import { ElTag, ElPopover, ElButton, ElTooltip } from "element-plus";
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  categories: {
    type: Array,
    required: true,
  },
  numbersToShow: {
    type: Number,
    default: 5,
  },
});

const router = useRouter();

const categories = computed(() => props.categories);
const numbersToShow = computed(() => props.numbersToShow);

const filteredCategories = computed(() =>
  structuredClone([...categories.value].slice(0, numbersToShow.value))
);

const moreCategories = computed(() =>
  structuredClone([...categories.value].splice(numbersToShow.value))
);

const redirectToSearch = (category) => {
  router.push({
    name: "search",
    query: {
      search: "",
      filter: "courses",
      category: category.id,
    },
  });
};

const wrapCategoryName = (name) => {
  return name.length > 15 ? name.slice(0, 15) + "..." : name;
};
</script>

<style lang="scss" scoped></style>
